import { css, styled } from 'canoe';
import React from 'react';

import { ValueBox, ValueToggle } from '@candu-ai/craft/ui';
import { useForm } from 'craft/state';

const StateLabel = styled.div`
  ${({ theme }) => css`
    padding: 0 ${theme.spaces.xs};
  `}
`;

interface Props {
  nodeId: string;
}

export const FormStateToggler = ({ nodeId }: Props) => {
  const {
    onSetStepId,
    activeStepId,
    submittedStepId,
    stepIds,
    shouldDisplayErrorState,
    setDisplayError,
    isSubmitStep,
  } = useForm(nodeId);

  const normalActive = stepIds.indexOf(activeStepId) >= 0 && !shouldDisplayErrorState;

  return (
    <>
      <ValueBox label="Form states" responsiveToggle>
        <ValueToggle
          toggleGroup="form-state"
          onClick={() => {
            setDisplayError(false);
            onSetStepId(stepIds[0]);
          }}
          isActive={normalActive}
          label={<StateLabel>Normal</StateLabel>}
        />
        <ValueToggle
          toggleGroup="form-state"
          onClick={() => {
            setDisplayError(false);
            onSetStepId(submittedStepId);
          }}
          isActive={isSubmitStep}
          label={<StateLabel>Submitted</StateLabel>}
        />
        <ValueToggle
          toggleGroup="form-state"
          onClick={() => setDisplayError(true)}
          isActive={shouldDisplayErrorState}
          label={<StateLabel>Error</StateLabel>}
        />
      </ValueBox>
    </>
  );
};
